import { countriesWithFlagsAndPrefix } from '@/constants/countries-with-flag';
import { PhonePrefix } from '@/types/other';
import { useEffect, useState } from 'react';

export default function usePhonePrefix(initialPrefix?: PhonePrefix | null) {
  const [currentPhonePrefix, setCurrentPhonePrefix] = useState<PhonePrefix>({
    prefix: countriesWithFlagsAndPrefix[13].phonePrefix,
    flag: countriesWithFlagsAndPrefix[13].flag,
  });

  useEffect(() => {
    if (initialPrefix) {
      setCurrentPhonePrefix(initialPrefix);
    }
  }, [initialPrefix]);

  return { currentPhonePrefix, setCurrentPhonePrefix };
}
